/**
 * User Role Constants
 * These values must match backend-auth/src/constants/roles.js
 * Backend is the source of truth for role definitions
 * Role 0 = root, 1 = editor, 2 = viewer, 3 = admin
 */
export const USER_ROLES = {
  ROOT: 0,
  EDITOR: 1,
  VIEWER: 2,
  ADMIN: 3,
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

